import { ChangeEvent, useEffect, useState } from 'react';
import './ClinicalProfessionalReference.scss';
import ClinicalProfessionalReferenceMobile from './ClinicalProfessionalReferenceMobile';
import { questions, supervisor } from "./QuestionData";
import { ClinicalProfessionalAnswers, ReferralData } from '../tp-core-types/ClinicalProFessionalAnswers';
import TPCoreAPI from '../tp-core-api/TPCoreAPI';
import { useParams } from 'react-router-dom';
import ClinicalProfessionalSubmissionConfirmation from './ClinicalProfessionalSubmissionConfirmation';

export default function ClinicalProfessionalReference(this: any) {
    const params = useParams<{ guid: string }>();
    const [buttonState, setButtonState] = useState<boolean>(false);
    const [submitted, setSubmitted] = useState<boolean>(false);
    const isMobile = window.matchMedia("(max-width: 800px)").matches;
    const [referralData, setReferralData] = useState<ReferralData>();
    const [answerObject, setAnswerObject] = useState<ClinicalProfessionalAnswers>({
        ReferenceGuid: params.guid || "",
        HistoryTypeId: "0",
        HcpName: "",
        HcpDiscipline: "",
        HcpSpecialty: "",
        WasCharge: false,
        EmrWorked: "",
        SafeCareLevel: 0,
        DependableLevel: 0,
        ProfessionalLevel: 0,
        CooperativeLevel: 0,
        CommunicatorLevel: 0,
        AttendanceLevel: 0,
        AssetLevel: 0,
        Comments: "",
        SupervisorName: "",
        SupervisorTitle: "",
        FacilityName: "",
        ReferenceDate: "",
        CityState: "",
        StartDate: "",
        EndDate: "",
        Unit: ""
    } as ClinicalProfessionalAnswers);

    const sortedSupervisor = supervisor
        .slice() // shallow copy so we don't mutate original
        .sort((a, b) => a.DesktopDisplayOrder - b.DesktopDisplayOrder);
    const maxSlots = 8; // or highest order you'd like (e.g., from your data or design)
    const placeholdersNeeded = maxSlots - sortedSupervisor.length;
    const placeholders = Array.from({ length: placeholdersNeeded }, (_, i) => ({
        question: "",
        id: `placeholder-${i + 1}`,
        name: "",
        DesktopDisplayOrder: sortedSupervisor.length + i + 1,
        isPlaceholder: true,
    }));
    const finalSupervisorList = [...sortedSupervisor, ...placeholders];

   

    function UpdateDataObject(answerObject: ClinicalProfessionalAnswers): import("react").ChangeEventHandler<HTMLInputElement> | undefined {
        return function (event: React.ChangeEvent<HTMLInputElement>) {
            const { name, value } = event.target;
            if (name === "WasCharge") {
                setAnswerObject((prevState) => ({
                    ...prevState || {} as ClinicalProfessionalAnswers,
                    [name]: value === "1" ? true : false,
                }));
            } else {
                setAnswerObject((prevState) => ({
                    ...prevState || {} as ClinicalProfessionalAnswers,
                    [name]: value,
                }));
            }
        };
    }
    function UpdateDataTextArea(answerObject: ClinicalProfessionalAnswers): import("react").ChangeEventHandler<HTMLTextAreaElement> | undefined {
        return function(event: React.ChangeEvent<HTMLTextAreaElement>) {
            const { name, value } = event.target;
            setAnswerObject((prevState) => ({
                ...prevState || {} as ClinicalProfessionalAnswers,
                [name]: value,
            }));
        };
        
    }
    useEffect(() => {
        if(
            answerObject.HistoryTypeId !== "0" &&
            answerObject.HcpName !== "" &&
            answerObject.HcpDiscipline !== "" &&
            answerObject.HcpSpecialty !== "" &&
            (answerObject.WasCharge === false || answerObject.WasCharge === true) &&
            // answerObject.EmrWorked !== "" &&
            answerObject.SafeCareLevel !== 0 &&
            answerObject.DependableLevel !== 0 &&
            answerObject.ProfessionalLevel !== 0 &&
            answerObject.CooperativeLevel !== 0 &&
            answerObject.CommunicatorLevel !== 0 &&
            answerObject.AttendanceLevel !== 0 &&
            answerObject.AssetLevel !== 0 &&
            answerObject.SupervisorName !== "" &&
            answerObject.SupervisorTitle !== "" &&
            answerObject.FacilityName !== "" &&
            answerObject.ReferenceDate !== null &&
            answerObject.CityState !== "" 
        )
        {
            setButtonState(true);
        }else{
            setButtonState(false);
        }
        
}, [answerObject]);

const getEnvironmentData = async () => {
    if (params.guid !== undefined && params.guid !== "") {
        const response = await TPCoreAPI.getReferenceAutoFillData(params.guid);
        setReferralData(response);
        if (response) {
            const data = response;
            setAnswerObject((prevState) => ({
                ...prevState || {} as ClinicalProfessionalAnswers,
                ReferenceGuid: params.guid,
                HistoryTypeId: data.historyTypeId,
                HcpName: data.name,
                HcpDiscipline: data.discipline,
                HcpSpecialty: data.specialty,
                SupervisorName: data.supervisorName,
                SupervisorTitle: data.supervisorTitle,
                FacilityName: data.facilityName,
                ReferenceDate: data.referenceDate,
                CityState: data.facCityState,
                StartDate: data.evalStartDate,
                EndDate: data.evalEndDate,
                WasCharge: data.wasCharge,
                Unit: ""
            }));
        }
    }
};
useEffect(() => {
    getEnvironmentData();
}, []);

    function UpdateDataTextInput(answerObject: ClinicalProfessionalAnswers): import("react").ChangeEventHandler<HTMLInputElement> | undefined {
    return function(event: ChangeEvent<HTMLInputElement>): void {
        const { name, value } = event.target;
        setAnswerObject((prevState) => ({
            ...prevState || {} as ClinicalProfessionalAnswers,
            [name]: value,
        }));
    };
    }

    function sendSubmit(){
        handleFormSubmit();
    }

    async function handleFormSubmit(): Promise<void> {
        const response = await TPCoreAPI.postClinicalProfessionalReference(answerObject);
        if (response.ok) {
            setSubmitted(true);
        } else {
            alert("Form submission failed");
        }
    }

    return(
        <>
        { !isMobile && 
        <div className='clinical-professional-reference'>
            <div className="clinical-professional-reference-container">
                <div className="clinical-professional-reference-title">Clinical & Professional Reference</div>
                <div className="clinical-professional-reference-divider">&nbsp;</div>
                <div className="clinical-professional-reference-description">As required by The Joint Commission (TLC), this form is requested to provide information on the competency and performance of the healthcare clinician for a contingency staff position.</div>
                
                <div className="clinical-professional-reference-block">
                    <div className="header clinical-professional-reference-block-row-one header">
                        <fieldset className="clinical-professional-reference-fieldset" data-testid="clinical-information" data-type="horizontal" data-role="controlgroup" data-label="Clinical Information">
                            <legend className="clinical-professional-reference-legend">CLINICAL INFORMATION</legend>
                            <div >
                                <input checked={answerObject.HistoryTypeId?.toString() === "1"} onChange={UpdateDataObject(this)} type="radio" name="HistoryTypeId" value="1" id="core-staff-full-time-yes" className="clinical-professional-reference-radio"/>
                                <label htmlFor="core-staff-full-time-yes">Core Staff (Full-Time)</label>
                            </div>
                            <div >
                                <input checked={answerObject.HistoryTypeId?.toString() === "4"} onChange={UpdateDataObject(this)} type="radio" name="HistoryTypeId" value="4" id="core-staff-part-time-yes" className="clinical-professional-reference-radio"/>
                                <label htmlFor="core-staff-part-time-yes">Core Staff (Part-Time)</label>
                            </div>
                            <div >
                                <input checked={answerObject.HistoryTypeId?.toString() === "3"} onChange={UpdateDataObject(this)} type="radio" name="HistoryTypeId" value="3" id="per-diem-yes" className="clinical-professional-reference-radio"/>
                                <label htmlFor="per-diem-yes">Per Diem</label>
                            </div>
                            <div >
                                <input checked={answerObject.HistoryTypeId?.toString() === "2"} onChange={UpdateDataObject(this)} type="radio" name="HistoryTypeId" value="2" id="travel-yes" className="clinical-professional-reference-radio"/>
                                <label htmlFor="travel-yes">Travel</label>
                            </div>
                        </fieldset>
                    </div>
                        
                    <div className="clinical-professional-reference-block-row">
                        <table className="clinical-professional-reference-table" border={1}>
                            <tbody>
                                <tr>
                                    <td className='form-label'>
                                        <label htmlFor="name">Name</label>
                                    </td>
                                    <td>
                                        <input onChange={UpdateDataObject(this)} value={answerObject.HcpName} type="text" id="name" name="HcpName" className="clinical-professional-reference-input"></input>
                                    </td>
                                    <td className="form-label">
                                        <label htmlFor="unit">Unit</label>
                                    </td>
                                    <td>
                                        <input onChange={UpdateDataObject(this)} value={answerObject.Unit} type="text" id="unit" name="Unit" className="clinical-professional-reference-input"></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="form-label">
                                        <label htmlFor="discipline">Discipline</label>
                                    </td>
                                    <td>
                                        <input onChange={UpdateDataObject(this)} value={answerObject.HcpDiscipline} type="text" id="discipline" name="HcpDiscipline" className="clinical-professional-reference-input"></input>
                                    </td>
                                    <td className="form-label">
                                        <label htmlFor="specialty">Specialty</label>
                                    </td>
                                    <td>
                                        <input onChange={UpdateDataObject(this)} value={answerObject.HcpSpecialty} type="text" id="specialty" name="HcpSpecialty" className="clinical-professional-reference-input"></input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>                        
                </div>
                <div className="clinical-professional-reference-block clinical-professional-reference-block-row">
                    <div className="header2">
                        The person has registered with TRS Healthcare and has listed you as a previous employer. We would appreciate your assistance in verifying that the employment information is correct and evaluating their job performance.
                    </div>
                    <table border={1}>
                        <tbody>
                            <tr className="background">
                                <td colSpan={2}>
                                    <div className='charge sub-header '>Was clinician ever in a Charge capacity?
                                        <div className='charge-answers'>
                                            <label htmlFor="charge-yes">Yes</label>
                                            <input  data-testid="charge-yes-input" checked={answerObject.WasCharge === true} onChange={UpdateDataObject(this)}  className="clinical-professional-reference-radio" id="charge-yes" type="radio" name="WasCharge" value="1"/>
                                        </div>
                                        <div className='charge-answers'>
                                            <label htmlFor="charge-no">No</label>
                                            <input data-testid="charge-no-input" checked={answerObject.WasCharge === false} onChange={UpdateDataObject(this)}  className="clinical-professional-reference-radio" id="charge-no" type="radio" name="WasCharge" value="0"/>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <label htmlFor="emr">EMR</label>
                                </td>
                                <td colSpan={2}>
                                    <input type="text" id="emr" onChange={UpdateDataObject(this)}  name="EmrWorked" className="clinical-professional-reference-input"></input>
                                </td>
                            </tr>
                            <tr className='form-label'>
                                <td>
                                    Clinical and Professional Evaluation
                                </td>
                                <td className="form-label">Exceeds Expectations</td>
                                <td className="form-label">Meets Expectations</td>
                                <td className="form-label">Needs Improvement</td>
                                <td className="form-label">Did not Observe</td>
                            </tr>
                            {questions.map((question, index) => (
                                <tr key={index} className="clinical-professional-reference-block-row">
                                    <td className="clinical-professional-reference-question">{question.question}
                                        <div className='clinical-professional-reference-question-sub-text'>{question.description}</div>
                                    </td>
                                    <td className="clinical-professional-reference-answer"><input onChange={UpdateDataObject(this)} type="radio" name={question.name} value="4" aria-label={`q${index} Exceeds Expectations`} id={`${index}Exceeds`} className="clinical-professional-reference-radio"/></td>
                                    <td className="clinical-professional-reference-answer"><input onChange={UpdateDataObject(this)} type="radio" name={question.name} value="3" aria-label={`q${index} Met Expectations`} id={`${index}Met`} className="clinical-professional-reference-radio"/></td>
                                    <td className="clinical-professional-reference-answer"><input onChange={UpdateDataObject(this)} type="radio" name={question.name} value="2" aria-label={`q${index} Needs Improvement`} id={`${index}Needs`} className="clinical-professional-reference-radio"/></td>
                                    <td className="clinical-professional-reference-answer"><input onChange={UpdateDataObject(this)} type="radio" name={question.name} value="1" aria-label={`q${index} Not Observed`} id={`${index}NA`} className="clinical-professional-reference-radio"/></td>
                                </tr>
                            ))}
                            
                            <tr className="clinical-professional-reference-block-row-footer">
                                <td colSpan={5}>
                                    <ul>
                                        <li>Exceeds Expectations: Performance consistently above job requirements.</li>
                                        <li>Meets Expectations: Performance consistently met job requirements.</li>
                                        <li>Needs Improvement: Performance did not fully meet expectations; improvement needed.</li>
                                        <li>Did not Observe: No direct observation of this behavior or skill.</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr className="clinical-professional-reference-block-row-comments">
                                <td colSpan={5} className="background">
                                    Comments:
                                </td>
                            </tr>
                            <tr className="clinical-professional-reference-block-row-comments">
                                <td colSpan={5}>
                                    <textarea onChange={UpdateDataTextArea(this)}
                                        aria-label="reference-comments"
                                        name="Comments"
                                        className="textarea-comments"
                                        rows={5}
                                        
                                        placeholder="Please type your comments here."
                                        id="reference-comments"
                                    ></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
                
                <div className="clinical-professional-reference-block clinical-professional-reference-block-row">
                    <div className="header2">SUPERVISOR SUBMITTING REFERENCE</div>
                    {/* <div className="flex-container">
                        {supervisor.map((question, index) => (
                            <div className={"flex-item order" + question.DesktopDisplayOrder} key={index}>
                                <label htmlFor={question.id}>{question.question}</label>
                                <div className="input-div">
                                    <input 
                                        value={answerObject[question.name as keyof ClinicalProfessionalAnswers] != null
                                            ? (question.name === "ReferenceDate" || question.name === "StartDate" || question.name === "EndDate" 
                                                ? String(answerObject[question.name as keyof ClinicalProfessionalAnswers]) :
                                                   String(answerObject[question.name as keyof ClinicalProfessionalAnswers]))
                                            : ""} 
                                        onChange={UpdateDataTextInput(this)} type="text" id={question.id} name={question.name} className="clinical-professional-reference-input"></input>
                                </div>
                            </div>
                        ))}
                    </div> */}
                    <div className="flex-container">
                        {finalSupervisorList.map((question, index) => (
                            <div
                                className={
                                    "flex-item order" + (index + 1) + 
                                    (question.isPlaceholder ? " placeholder" : "")
                                }
                                key={index}
                            >
                                {!question.isPlaceholder && (
                                    <>
                                        <label htmlFor={question.id}>{question.question}</label>
                                        <div className="input-div">
                                            <input 
                                                value={answerObject[question.name as keyof ClinicalProfessionalAnswers] != null
                                                    ? String(answerObject[question.name as keyof ClinicalProfessionalAnswers])
                                                    : ""} 
                                                onChange={UpdateDataTextInput(this)}
                                                type="text"
                                                id={question.id}
                                                name={question.name}
                                                className="clinical-professional-reference-input"
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            {!isMobile && <div className="submit-button-container">
            <button disabled={!buttonState} onClick={sendSubmit} className="submit-button">Submit</button>
        </div>}    
            </div>
        </div>                    
        }
        { isMobile && referralData && <ClinicalProfessionalReferenceMobile 
            defaultValues={referralData} 
            answerUpdated={function (answers: ClinicalProfessionalAnswers): void {
                setAnswerObject((prState) => ({...prState || {} as ClinicalProfessionalAnswers, ...answers, ReferenceGuid: params.guid || ""}));
            } } ></ClinicalProfessionalReferenceMobile>}
 
        { isMobile && <div className="submit-button-container mt-1">
            <button disabled={!buttonState} onClick={sendSubmit} className="submit-button">Submit</button>
        </div>}
        {submitted && <ClinicalProfessionalSubmissionConfirmation />}
        </>
    );
}